import { render, staticRenderFns } from "./newTotalLevelAnalysis.vue?vue&type=template&id=b4d69884&scoped=true"
import script from "./newTotalLevelAnalysis.vue?vue&type=script&lang=js"
export * from "./newTotalLevelAnalysis.vue?vue&type=script&lang=js"
import style0 from "./newTotalLevelAnalysis.vue?vue&type=style&index=0&id=b4d69884&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d69884",
  null
  
)

export default component.exports